import React from 'react';
import { CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { KanjiBackdrop, Mandala, Seal } from './Ornaments';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-31" data-mp="qo1nj8pmhq0h">
      <div className="paper-card relative overflow-hidden rounded-sm border border-brand-gold/55 p-7 text-center shadow-[0_18px_48px_rgba(44,38,32,0.13)] md:p-12" data-id="element-32" data-mp="qn01k972jj3z">
        <KanjiBackdrop glyphs={['選', '擇', '今', '始', '道']} data-id="element-33" data-mp="hlk0wt622vcy" />
        <Mandala className="absolute -right-20 -top-20 h-64 w-64 opacity-10" color="#A98546" data-id="element-34" data-mp="cnii89cjky20" />
        <Mandala className="absolute -bottom-24 -left-24 h-64 w-64 opacity-10" color="#4A6B57" data-id="element-35" data-mp="7oxg24dqc4ax" />
        <div className="relative" data-id="element-36" data-mp="2708dauencdaz">
          <h2 className="font-display text-3xl font-bold text-brand-ink md:text-5xl" data-id="element-37" data-mp="26zfbm7ujodzp">
            Hay dos versiones de vos en este momento.
          </h2>
          <div className="mx-auto mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-brand-text md:text-lg" data-id="element-38" data-mp="351hgedljix86">
            <p data-id="element-39" data-mp="3a36vc4bvvv1j">
              Una que cierra esta página y la próxima sesión sigue dependiendo
              únicamente de su memoria. Sin un atlas visual que respalde cada
              punto. Sin protocolos clínicos organizados por patología. Sin el
              material técnico que sus pacientes merecen ver mientras están en la
              camilla.
            </p>
            <p className="font-semibold text-brand-forest" data-id="element-40" data-mp="3ssd717e9fmdu">
              Y otra que decide que hoy es el día en que su práctica de
              acupuntura cambia para siempre.
            </p>
            <p className="font-display text-xl italic text-brand-goldDark" data-id="element-41" data-mp="3j1scpw5md40q">
              La pregunta no es si podés pagarlo.
              <br data-id="element-42" data-mp="alp3hlyuz7aa" />
              La pregunta es cuántas sesiones más vas a trabajar sin el sistema
              visual que tu práctica y tus pacientes necesitan.
            </p>
          </div>
          <div className="mx-auto mt-12 max-w-md rounded-sm border-2 border-brand-burgundy bg-brand-paper p-6 shadow-lg" data-id="element-43" data-mp="p7w74sad189a">
            <span className="-mt-10 inline-block rounded-sm bg-brand-burgundy px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-brand-paper" data-id="element-44" data-mp="kavxk7eaxndf">
              ✦ Más elegido
            </span>
            <h3 className="mt-4 font-serif text-lg font-bold text-brand-ink md:text-xl" data-id="element-45" data-mp="bbiovgy052tr">
              ATLAS ANCESTRAL DE ACUPUNTURA™
            </h3>
            <p className="mt-3 text-sm text-brand-muted line-through" data-id="element-46" data-mp="1jcww77r2lek">
              $95.000 ARS
            </p>
            <p className="font-serif text-4xl font-bold text-brand-burgundy" data-id="element-47" data-mp="3sqxtaks8ag8u">
              $27.990 ARS
            </p>
            <p className="mt-4 text-sm leading-relaxed text-brand-muted" data-id="element-48" data-mp="3opvprrra3i12">
              3 Tomos + 6 Bonos · 118 páginas + material completo. El sistema
              visual de acupuntura clínica más completo en español para
              terapeutas que quieren aplicar con precisión, velocidad y autoridad
              profesional.
            </p>
            <CTAButton fullWidth className="mt-6 py-3.5 text-sm" data-id="element-49" data-mp="1z6xc33icit0e">
              → QUIERO MI ATLAS ANCESTRAL $27.990
            </CTAButton>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-brand-muted md:text-sm" data-id="element-50" data-mp="2471pulrvd9mx">
            <span className="inline-flex items-center gap-1" data-id="element-51" data-mp="285j0hfai1293">
              <LockKeyholeIcon className="h-4 w-4" data-id="element-52" data-mp="1biw3xvp2xeli" />
              Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-53" data-mp="1ghh45v4bzy9y">
              <ZapIcon className="h-4 w-4" data-id="element-54" data-mp="1khrcvfjid2si" />
              Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-55" data-mp="1p9j4zuibbgkr">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-56" data-mp="1pb41hpo6t9l9" />
              Garantía 7 días
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-57" data-mp="sp0o1q45mgda">
              <CreditCardIcon className="h-4 w-4" data-id="element-58" data-mp="wrdtseiwiea2" />
              Mercado Pago | Tarjeta
            </span>
          </div>
          <div className="mt-8 flex items-start gap-4 rounded-sm border border-brand-gold/40 bg-brand-surfaceLight/55 p-5 text-left text-sm leading-relaxed text-brand-text" data-id="element-59" data-mp="dod31663rrsl">
            <Seal characters="附記" className="mt-0.5 text-[11px]" data-id="element-60" data-mp="ney6b6wq1khu" />
            <div data-id="element-61" data-mp="ing7aoe9dtzi">
              <p data-id="element-62" data-mp="imwmmzx84rhs">
                <strong className="text-brand-ink" data-id="element-63" data-mp="imem3r3j3r42">P.D.:</strong> Si tenés dudas,
                escribinos a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-64" data-mp="wcqezs7xttw9">
                  {SUPPORT_EMAIL}
                </a>
                , a{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href="https://instagram.com/lumen.akasha" data-id="element-65" data-mp="11dec8vmrf6yx">
                  @lumen.akasha
                </a>{' '}
                en Instagram o por WhatsApp al{' '}
                <a className="font-semibold text-brand-forest underline-offset-2 hover:underline" href={WHATSAPP_URL} data-id="element-66" data-mp="1io1i0nrx7pcw">
                  {WHATSAPP_LABEL}
                </a>
                . Te respondemos hoy.
              </p>
              <p className="mt-3 italic text-brand-goldDark" data-id="element-67" data-mp="1dvqhbipcvzja">
                El precio de lanzamiento sube pronto. El mejor momento para tener
                tu sistema visual de acupuntura clínica es ahora.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}